<?xml version="1.0" encoding="UTF-8"?>
<map version="1.10" tiledversion="1.11.0" orientation="orthogonal" renderorder="right-down" compressionlevel="0" width="189" height="32" tilewidth="16" tileheight="16" infinite="0" nextlayerid="21" nextobjectid="276">
 <tileset firstgid="1" name="tiles" tilewidth="16" tileheight="16" tilecount="192" columns="16">
  <image source="../images/tileset.png" width="256" height="192"/>
  <tile id="0" type="www" probability="6"/>
  <tile id="9" type="oneWay"/>
  <tile id="10" type="oneWay"/>
  <tile id="73" type="oneWay"/>
  <tile id="74" type="oneWay"/>
  <tile id="94" type="oneWay"/>
  <tile id="95" type="oneWay"/>
  <tile id="96" type="noCollide"/>
  <tile id="114" type="noCollide"/>
  <tile id="115" type="noCollide"/>
  <tile id="123" type="noCollide"/>
  <tile id="128" type="noCollide"/>
  <tile id="129" type="noCollide"/>
  <tile id="147" type="noCollide"/>
  <tile id="148" type="noCollide"/>
  <tile id="149" type="noCollide"/>
  <tile id="150" type="noCollide"/>
  <tile id="151" type="noCollide"/>
  <tile id="163">
   <animation>
    <frame tileid="163" duration="200"/>
    <frame tileid="164" duration="200"/>
    <frame tileid="165" duration="200"/>
    <frame tileid="164" duration="200"/>
   </animation>
  </tile>
  <tile id="166">
   <animation>
    <frame tileid="166" duration="300"/>
    <frame tileid="167" duration="300"/>
   </animation>
  </tile>
  <tile id="168">
   <animation>
    <frame tileid="168" duration="200"/>
    <frame tileid="169" duration="200"/>
    <frame tileid="170" duration="200"/>
    <frame tileid="169" duration="200"/>
   </animation>
  </tile>
  <tile id="176">
   <animation>
    <frame tileid="176" duration="100"/>
    <frame tileid="177" duration="100"/>
    <frame tileid="178" duration="100"/>
    <frame tileid="179" duration="100"/>
    <frame tileid="180" duration="100"/>
   </animation>
  </tile>
  <tile id="181">
   <animation>
    <frame tileid="181" duration="100"/>
    <frame tileid="182" duration="100"/>
    <frame tileid="183" duration="100"/>
    <frame tileid="184" duration="100"/>
    <frame tileid="185" duration="100"/>
    <frame tileid="184" duration="100"/>
    <frame tileid="183" duration="100"/>
    <frame tileid="182" duration="100"/>
    <frame tileid="181" duration="100"/>
   </animation>
  </tile>
  <tile id="186">
   <animation>
    <frame tileid="186" duration="100"/>
    <frame tileid="187" duration="100"/>
    <frame tileid="188" duration="100"/>
    <frame tileid="189" duration="100"/>
    <frame tileid="190" duration="100"/>
    <frame tileid="187" duration="100"/>
   </animation>
  </tile>
 </tileset>
 <layer id="1" name="background" width="189" height="32">
  <data encoding="base64" compression="zlib">
   eAHtW9eKVEEQXcyCOaIYVl1zjvhgdtUVX1TMCVREDBjAjIqPigH/QIXF8JeeWm8NRVM9c+/MMrftOQ1nurq6bnfV6TPNDjPb18dGBsgAGSAD3WBgDDYZ242NuAcZSISBcchDwEYGcmdgPAqcAFDzuZ8067MMTKTmLR20e4QB3vM9ctAss8GAan5Sw0ODDOTNgGp+ct5lsjoy0GBANd9w0CADmTNAzWd+wCxvhIEphgdq3pBBMysGpppqpsGeDswAqHlDDM1sGJiJSmYF1czGeA5AzQfEcJgNA6Jtr5XRPH+T4zFHX+oMdKL5Mu+L1Otnfr3HQAqat58peu8EWHG3Gahb895nim5zwP16i4FQ81V+Vxn722ZuRQrDHCo+znAyUIkBT29lf1cZ07y3ZrOkJH5eswDO1crA/Fp3H/3NY3qL6bnM91btaH70K+OKnTAQnnMna6XwbJl6VPMLkPBCk7R+byUujQnv6Jjm5b7w/u6JxZttszAXoYrFwBJgaeIV6Tnr95Neunvg3Avs8ybh6weWAcuBFUCdTeuRHGJ6Uz0POIm2+t6q1Zr6PrKfHZxtsnKtRDWrgNXAGmAtsA5Iudlz1jOz+Z7E4BRw2jqNvR72BmCj8dVp2nq8PFTz3pz6wphWGtb4AV0AvX52MK5SZj+iUrlDyiS8CUGbgS3AVmAbsB34H5qcmz0zzfluYdxTh9PvgG8nsMuZq8sl9XhN/LE5jfdiVMPe/5p48bJWq310P9undofY3Dx7P5wHgIPAIeAwULWdcB7wfBLm+T2fXTI2Hzufj8XDn+wigT2I8RHgKHA/mKtrGKtH/LE5zTUWI37vf02axeuaVfoU75BjKGAIOB4Ucgbjs8A54DxwAajabjsPeD4J8/yezy4Zm4/p4K19uLAvBr5LGF8GZI3PwVxdw1g9MX3aPGMxVdeMxdu9PHsQztTukCvI6SpwLUj4AcYPAeXsEezHJibUiplqmJ4mPZ884Pk9X2Nx55kv8F0HJOcngLSnwDPgOSD+F8BL4BUg7c6/buT1NV7fALGaTWhlswxfdtHdZiD5hE3r1Fp/IuAP8BsYLoJtzI3Cp523psyJ35vzfLpWs76dO6QqV3Z/0UCrJpr/CrwDQn1o/bZ/j7gPgNUKhiPtJl5vFbbt5Pz0DEMdfysCrV9j7Rop2aKvYeCXk5TWE05Zvr5j8ocJEN5kLell3Vxau3dIM65y4YZ1kAEyQAbIABkgA2SADJCBuhj4CyvmPtc=
  </data>
 </layer>
 <layer id="2" name="main" width="189" height="32">
  <data encoding="base64" compression="zlib">
   eAHt2kEOgjAQBVBiXOEFPJOn8AYu3XoFb+ywwFSDhBaNQB9JEwId6Tx/TDU2jYMAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQLbEmijncO2WtINAQIECBAgQOApEPucW7ff6YaDAAECBNYp4LN8ne+bVRMgQGBIoN+bz/lNck7t0JpcI0CAAIFlC/TfB5a9SqsjQIAAAQIECJQLHMtLVRIgQIAAgeoETtHx2EhBxual9z7VpNedlwm0Ueb/yWV2tVada21c3wQIVClwia73ybhnKkypf5+TPu/X55ntZE//Z29T7LIb+nLBLl7vGmPKWs3hJAMyIAMyIAMyIAMyIAOvGXgA9bIYkQ==
  </data>
 </layer>
 <objectgroup id="3" name="objects">
  <properties>
   <property name="collide" type="bool" value="true"/>
  </properties>
  <object id="159" name="Player" type="player" x="32" y="416" width="13" height="35"/>
  <object id="69" name="Spikes" type="spikes" x="1440" y="440" width="64" height="16"/>
  <object id="165" name="bat" type="bat" x="912" y="352" width="8" height="16"/>
  <object id="227" type="item" gid="177" x="2512" y="144" width="16" height="16"/>
  <object id="228" type="item" gid="187" x="2384" y="256" width="16" height="16"/>
  <object id="229" type="item" gid="187" x="2720" y="288" width="16" height="16"/>
  <object id="231" type="box" gid="163" x="272" y="464" width="16" height="16"/>
  <object id="232" type="box" gid="163" x="288" y="464" width="16" height="16"/>
  <object id="233" type="box" gid="163" x="288" y="447" width="16" height="16"/>
  <object id="234" type="box" gid="163" x="288" y="430" width="16" height="16"/>
  <object id="236" type="box" gid="163" x="304" y="464" width="16" height="16"/>
  <object id="237" type="box" gid="163" x="304" y="447" width="16" height="16"/>
  <object id="238" type="box" gid="163" x="304" y="430" width="16" height="16"/>
  <object id="239" type="box" gid="163" x="304" y="413" width="16" height="16"/>
  <object id="240" type="zombie" x="416" y="432" width="10" height="32"/>
  <object id="241" type="zombie" x="144" y="432" width="10" height="32"/>
  <object id="242" name="bat" type="bat" x="215" y="384" width="8" height="16"/>
  <object id="243" type="zombie" x="592" y="416" width="10" height="32"/>
  <object id="244" type="zombie" x="800" y="416" width="10" height="32"/>
  <object id="245" type="zombie" x="1040" y="416" width="10" height="32"/>
  <object id="247" type="zombie" x="1584" y="400" width="10" height="32"/>
  <object id="248" type="zombie" x="1808" y="400" width="10" height="32"/>
  <object id="249" type="zombie" x="2032" y="416" width="10" height="32"/>
  <object id="250" type="zombie" x="2128" y="416" width="10" height="32"/>
  <object id="251" type="zombie" x="2224" y="416" width="10" height="32"/>
  <object id="252" type="zombie" x="2272" y="416" width="10" height="32"/>
  <object id="253" type="zombie" x="2480" y="400" width="10" height="32"/>
  <object id="254" type="zombie" x="2640" y="400" width="10" height="32"/>
  <object id="255" type="zombie" x="2832" y="400" width="10" height="32"/>
  <object id="256" type="zombie" x="1328" y="416" width="10" height="32"/>
  <object id="258" type="zombie" x="1216" y="416" width="10" height="32"/>
  <object id="260" name="bat" type="bat" x="1573" y="339" width="8" height="16"/>
  <object id="261" name="bat" type="bat" x="1656" y="360" width="8" height="16"/>
  <object id="262" type="item" gid="187" x="256" y="384" width="16" height="16"/>
  <object id="263" type="item" gid="177" x="1968" y="416" width="16" height="16"/>
  <object id="267" type="box" gid="163" x="688" y="448" width="16" height="16"/>
  <object id="268" type="box" gid="163" x="704" y="448" width="16" height="16"/>
  <object id="269" type="box" gid="163" x="704" y="432" width="16" height="16"/>
  <object id="270" type="item" gid="187" x="1184" y="384" width="16" height="16"/>
  <object id="271" type="zombie" x="1680" y="400" width="10" height="32"/>
  <object id="272" type="zombie" x="2176" y="416" width="10" height="32"/>
  <object id="273" type="zombie" x="2352" y="416" width="10" height="32"/>
  <object id="274" type="zombie" x="912" y="416" width="10" height="32"/>
 </objectgroup>
 <layer id="4" name="foreground" width="189" height="32">
  <data encoding="base64" compression="zlib">
   eAHtlllKQ0EQRfORPTktQN2DExjFHxHEf4cdOLuAgLhL7w3vStFEQniSqDkF166uHqrrvAo4GGAQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQhAAAIQgAAEIAABCEAAAhCAAAQgAAEIQAACEIAABCAAAQgsi8DZshL3yLutszvSbo87OLq6BP5iz+/pc+1LBzM+26HWj2bsYfl/E1hTecfSSDqRNqRzaR5b12ZrLPl8a87h9eT5kO9cmdt3fs+/s+TI2O67VuCmk9+wKW1Jrd0qcNcGf2Dut7t+15F6ap1+d8sm76scUl/u8+j7atw5Mpc7yelc753vNZ85lX6L+U15Y+p1zLVcSn5vag43j+HpNe/P2TD2fFrMrL2/StMvG8qLHMw9HuuZGo/v/Tnr8V56kB7LeCG/7lmkf6XcMdfyJD1Lr41emrnXp8XeFE+vyp3YIuuZN5d/B/5WI6n23Libp9e8XvsoczPz3nzvnMu9WffoPR59Nn0sd2JD/UUwoAfoAXqAHqAH6IG+PdD9a8EAgZUh8Al4IFJh
  </data>
 </layer>
</map>
